import config from "../../config";
import $ from "jquery";
import { useState } from "react";
import "./style.css";
import leftImg from "../../images/login_left.png";
import bottomImg from "../../images/login_bottom.png";
import loginIcon from "../../images/login_icon.png";
import { useFormik } from "formik";
import loginSchema from "../../validations/loginSchema";
import { inputChangeFocus, inputOnlyNumber } from "../../utils";
import axios from "axios";
import { saveThemeBtnColor } from "../../themeManager";

function LoginPinBased() {
  const [isSubmit, setIsSubmit] = useState(false);
  const [isOtpSend, setIsOtpSend] = useState(false);
  const [error, setError] = useState("");
  // const [prvOtp, setPrvOtp] = useState("");
  const [token, setToken] = useState();
  const [compId, setCompId] = useState();

  const loginFormik = useFormik({
    initialValues: { mobile: "", country: "+256" },
    validationSchema: loginSchema.validateLogin(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setIsSubmit(true);
      await $.post(
        `${config.apiUrl}/userlogin`,
        JSON.stringify({
          mobile: values.mobile,
          envinfo: "Web",
          versioninfo: "1.0",
          otherinfo: "{}",
        }),
      )
        .done(function (res) {
          setIsOtpSend(true);
          // setPrvOtp(res?.data?.otp);
          setToken(res.data.token);
          setCompId(res.data?.comp_data[0].comp_id);
          setError("");
        })
        .catch(function (err) {
          setError(err.responseJSON.data.message);
          setTimeout(() => {
            setError("");
          }, 3500);
        })
        .always(function () {
          setIsSubmit(false);
        });
    },
  });
  const otpFormik = useFormik({
    initialValues: { otp: [] },
    validationSchema: loginSchema.validateOtp(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setIsSubmit(true);
      const loginToken = { headers: { "access-token": token } };
      try {
        let { data } = await axios.post(
          `${config.apiUrl}/userVerify`,
          {
            mobile: loginFormik.values.mobile,
            pin: values.otp.join(""),
            // fcm: "Web",
            comp_id: compId,
          },
          loginToken,
        );

        // if (data?.userexist?.role_id === 5) {
        //   setError("Invalid user");
        //   setTimeout(() => {
        //     window.location.href = config.baseUrl + "/login";
        //   }, 1000);
        //   return 0;
        // }
        // localStorage.setItem(
        //   "inventory",
        //   JSON.stringify({
        //     token: data.data.userexist.token,
        //     userData: data.data.userexist,
        //   })
        // );
        if (data?.data?.role_id === 5) {
          setError("Invalid user");
          setTimeout(() => {
            window.location.href = config.baseUrl + "/login";
          }, 1000);
          return 0;
        }
        localStorage.setItem(
          "inventory",
          JSON.stringify({
            token: data.data.token,
            userData: data.data,
          }),
        );
        if (data?.data?.theme_color) {
          saveThemeBtnColor(data.data.theme_color);
        }
        // return;
        window.location.href = config.baseUrl + "/dashboard";
        setIsSubmit(false);
      } catch (error) {
        setError(error.response.data.data.message);
        setTimeout(() => {
          setError("");
        }, 3500);
        setIsSubmit(false);
      }
    },
    onReset: async (values) => {
      otpFormik.setFieldValue("otp", "");
    },
  });

  let lastKey = null;
  function inputMobile(e) {
    if (e.ctrlKey || e.metaKey) {
      return true;
    }

    let allowKeys = [
      "Tab",
      "Backspace",
      "Delete",
      "Enter",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
    ];

    if (!/^[0-9]$/.test(e.key) && !allowKeys.includes(e.key)) {
      e.preventDefault();
    }
  }

  const handlePaste = (e) => {
    e.preventDefault();

    let paste = (e.clipboardData || window.clipboardData).getData("text");

    paste = paste.replace(/[^\d]/g, "");
    document.execCommand("insertText", false, paste);
  };
  return (
    <>
      <div className="container-fluid p-0">
        <div className="row g-0 vh-100">
          <div className="col-sm-5">
            <img
              src={leftImg}
              className="img-fluid w-100"
              alt=""
              id="leftImg"
            />
          </div>
          <div className="col-sm-7 position-relative">
            <img
              src={bottomImg}
              className="position-absolute bottom-0 start-0 img-fluid"
              alt=""
            />
            <div className="row h-100 justify-content-center align-items-center mx-0">
              <div className="col-sm-8">
                <form
                  onReset={otpFormik.handleReset}
                  onSubmit={
                    isOtpSend
                      ? otpFormik.handleSubmit
                      : loginFormik.handleSubmit
                  }
                  autoComplete="off"
                >
                  <div className="card py-4 px-3">
                    {isOtpSend ? (
                      <>
                        <div className="card-body">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              setIsOtpSend(false);
                              setError("");
                              otpFormik.handleReset();
                            }}
                          >
                            Go back
                          </span>
                          <h1>Verification Pin</h1>

                          <strong>
                            ({loginFormik.values.country}){" "}
                            {loginFormik.values.mobile}
                            {/* ({prvOtp}) */}
                          </strong>

                          <div className="my-5 d-flex justify-content-center">
                            <input
                              type="password"
                              className="form-control otp"
                              autoFocus
                              maxLength="1"
                              name="otp[0]"
                              id="otp0"
                              onKeyDown={inputOnlyNumber}
                              onKeyUp={(e) =>
                                inputChangeFocus(e, "otp1", "otp0")
                              }
                              onChange={otpFormik.handleChange}
                              onBlur={otpFormik.handleBlur}
                            />
                            <input
                              type="password"
                              className="form-control otp"
                              maxLength="1"
                              name="otp[1]"
                              id="otp1"
                              onChange={otpFormik.handleChange}
                              onKeyDown={inputOnlyNumber}
                              onKeyUp={(e) =>
                                inputChangeFocus(e, "otp2", "otp0")
                              }
                              onBlur={otpFormik.handleBlur}
                            />
                            <input
                              type="password"
                              className="form-control otp"
                              maxLength="1"
                              name="otp[2]"
                              id="otp2"
                              onChange={otpFormik.handleChange}
                              onKeyDown={inputOnlyNumber}
                              onKeyUp={(e) =>
                                inputChangeFocus(e, "otp3", "otp1")
                              }
                              onBlur={otpFormik.handleBlur}
                            />
                            <input
                              type="password"
                              className="form-control otp"
                              maxLength="1"
                              name="otp[3]"
                              id="otp3"
                              onChange={otpFormik.handleChange}
                              onKeyDown={inputOnlyNumber}
                              onKeyUp={(e) =>
                                inputChangeFocus(e, "otp3", "otp2")
                              }
                              onBlur={otpFormik.handleBlur}
                            />
                          </div>
                          {otpFormik.touched.otp && otpFormik.errors.otp ? (
                            <div className="alert alert-danger text-center small py-1">
                              {otpFormik.errors.otp}
                            </div>
                          ) : error ? (
                            <div className="alert alert-danger text-center small py-1">
                              {error}
                            </div>
                          ) : null}
                          <div className="d-grid mb-3">
                            <button
                              className="btn btn-primary"
                              type="submit"
                              disabled={isSubmit}
                            >
                              {isSubmit && (
                                <span className="spinner-border spinner-border-sm me-2"></span>
                              )}
                              Login
                              <img
                                src={loginIcon}
                                className="img-fluid ms-2"
                                alt=""
                              />
                            </button>
                          </div>
                          {/* <p className="text-center text-grey">
                            This Session will end in 60 seconds. Didn’t <br />{" "}
                            receive a code?{" "}
                            <strong className="text-primary" role="button">
                              Resend Code
                            </strong>
                          </p> */}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="card-body">
                          <p>Welcome back</p>
                          <h1 className="mb-4">Login to your account</h1>
                          <div className="mb-5">
                            <label htmlFor="mobile">Mobile No</label>
                            <div className="row g-0">
                              <div style={{ width: "80px" }}>
                                <select
                                  className="form-select no-border-right"
                                  {...loginFormik.getFieldProps("country")}
                                >
                                  {(config?.countryCodes || []).map((v, i) => (
                                    <>
                                      <option key={`lcc_` + i} value={v}>
                                        {v}
                                      </option>
                                    </>
                                  ))}
                                </select>
                              </div>
                              <div className="col">
                                <input
                                  type="text"
                                  autoFocus
                                  className="form-control no-border-left"
                                  style={{ boxShadow: "none" }}
                                  maxLength="15"
                                  onKeyDown={inputMobile}
                                  onPaste={handlePaste}
                                  {...loginFormik.getFieldProps("mobile")}
                                />
                              </div>
                            </div>
                          </div>
                          {loginFormik.touched.mobile &&
                          loginFormik.errors.mobile ? (
                            <div className="alert alert-danger text-center small py-1">
                              {loginFormik.errors.mobile}
                            </div>
                          ) : error ? (
                            <div className="alert alert-danger text-center small py-1">
                              {error}
                            </div>
                          ) : null}
                          <div className="d-grid mb-3">
                            <button
                              className="btn btn-primary"
                              type="submit"
                              disabled={isSubmit}
                            >
                              {isSubmit && (
                                <span className="spinner-border spinner-border-sm me-2"></span>
                              )}
                              Next
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPinBased;
